import React from 'react';
import { useLabels } from 'wsm-common-data';
import PropTypes from 'prop-types';

const STLVideo = ({
	commercialVideoHeadline,
	headerTitle,
	headerCopy,
	youtubeLink
}) => {
	const labels = useLabels();
	return (
		<>
			<h3 className="p-8 mt-10 text-neutral-0 text-bold text-center bg-video-headline">
				{commercialVideoHeadline}
			</h3>
			<div className="m-auto bg-white px-md-15 pt-5 pb-8">
				<div className="row px-md-15 px-6">
					<div className="col-xs-12">
						<div className="embed-responsive embed-responsive-16by9">
							{youtubeLink && (
								<iframe
									title={youtubeLink}
									className="embed-responsive-item"
									src={`${youtubeLink}?rel=0&showinfo=0&enablejsapi=1`}
									frameBorder="0"
									allowFullScreen
								/>
							)}
						</div>
					</div>
				</div>
				<div className="text-center row mx-0 px-4">
					<div className="col-xs-12">
						<h2 className="h1">{headerTitle}</h2>
						<p className="ddc-font-size-large lead">
							{labels.getHTML(headerCopy)}
						</p>
					</div>
				</div>
			</div>
		</>
	);
};

export default STLVideo;

STLVideo.propTypes = {
	commercialVideoHeadline: PropTypes.string.isRequired,
	youtubeLink: PropTypes.string.isRequired,
	headerTitle: PropTypes.string.isRequired,
	headerCopy: PropTypes.string.isRequired
};
